module.exports = __webpack_public_path__ + "img/logos.eee52a6d.png";